import React from 'react';
import ListEmptyView from 'design-system/ListEmptyView';
const strings = {
    title: 'No results',
    subtitle: 'Try searching for another\nmerchant',
};
const NoSearchResults = () => (<ListEmptyView compact onCard title={strings.title} subTitle={strings.subtitle}/>);
export default NoSearchResults;
